<!--
@component

A horizontal line divider within a context menu.
```svelte
<ContextMenuSeparator />
```
-->
<svelte:options immutable />

<script lang="ts">
import type { ClassValue } from 'svelte/elements';

/** Additional CSS classes to pass to the separator. */
let extraClasses: ClassValue = '';
export { extraClasses as cx };
</script>

<hr class={['border-light mt-1 mb-0.5 shadow-none', extraClasses]} />
